export default __webpack_public_path__ + "static/media/Rayzon 1080_1920.cd63129d.webm";